/**
 * ConnectorStatusChip — tiny pill for active / error / disabled.
 * Colors use the shared palette so they track theme flips.
 */

import { useTranslation } from 'react-i18next';

import type { ConnectorStatus } from '@/api/types';

const CLASS: Record<ConnectorStatus, string> = {
  active:   'bg-success-soft text-success border-success/30',
  error:    'bg-warn-soft text-warn border-warn/30',
  disabled: 'bg-surface-raised text-ink-subtle border-border',
};

const DOT: Record<ConnectorStatus, string> = {
  active:   'bg-success',
  error:    'bg-warn',
  disabled: 'bg-ink-subtle',
};

export function ConnectorStatusChip({ status }: { status: ConnectorStatus }) {
  const { t } = useTranslation('connectors');
  return (
    <span
      className={
        'inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-[11px] font-medium ' +
        CLASS[status]
      }
    >
      <span className={'h-1.5 w-1.5 rounded-full ' + DOT[status]} aria-hidden="true" />
      {t(`status.${status}`)}
    </span>
  );
}
